import React from 'react'
import {Link} from 'react-router-dom'
import CompLinkHeader from 'components/riwayat/compLinkHeader'
import {Container} from 'react-bootstrap'
import './style.css'

export default function main() {
    return (
        <Container className="compoent-rekening">
            <CompLinkHeader to="/profile" back="Transaksi" title="Nomor Rekening Terdaftar" Ctitle="cls-comp-rek" />
            <Alamat />
        </Container>
    )
}



function Alamat() {
    return (
        <div className="rekening-content">
            <Container className="comp-alamat">
              <div className="comp-title">
                 <p className="name">Rifki</p>
                 <p className="bank">Bank BCA</p>
                 <p className="phone">7230481081</p>
                 <Link to="#">Ubah Alamat</Link>
              </div>
            </Container>
        </div>
    )
}
